import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";

import { Component, OnInit } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

import { AppInfoDbService } from "../../../../_services/database/app-info-db.service";
import { SpinnerService } from "../../../../_services/spinner.service";
import { IplexDeviceSyncService } from "../../../services/iplex-device-sync.service";
import { CustomValidators } from "../../../../_shared/custom-validator";
import { IplexDeviceConnectModeService } from "../../../services/iplex-device-connect-mode.service";

@Component({
  selector: "app-iplex-device-start-connect-dialog",
  templateUrl: "./iplex-device-start-connect-dialog.component.html",
  styleUrls: ["./iplex-device-start-connect-dialog.component.scss"],
  standalone: false
})
export class IplexDeviceStartConnectDialogComponent implements OnInit {
  readonly clientNameMaxLength = 63;
  readonly clientNameRegex = /^[\x20-\x7e|\uFF61-\uFF9F|\xA0-\xFF]*$/;

  clientNameControl = new FormControl<string>({ value: "", disabled: true });
  onDestroy$ = new Subject();
  public isConfirmedGuidanceMessage: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<IplexDeviceStartConnectDialogComponent>,
    private iplexDeviceConnectModeService: IplexDeviceConnectModeService,
    private iplexSyncService: IplexDeviceSyncService,
    private appInfoDbService: AppInfoDbService,
    private spinner: SpinnerService
  ) {}

  ngOnInit() {
    this.spinner.show(true);
    this.appInfoDbService.get().subscribe(
      (appInfo) => {
        this.setFormValue(appInfo ? appInfo.currentClientName : "");
        this.spinner.hide(true);
      },
      (error) => {
        console.log(error);
        this.setFormValue("");
        this.spinner.hide(true);
      }
    );
  }

  setFormValue(clientName: string) {
    this.clientNameControl = new FormControl<string>({ value: clientName, disabled: false }, [
      CustomValidators.requiredTrimmed(),
      Validators.maxLength(this.clientNameMaxLength),
      Validators.pattern(this.clientNameRegex)
    ]);
  }

  connect() {
    if (this.clientNameControl.invalid) {
      return;
    }

    this.appInfoDbService.putClientName(this.clientNameControl.value).subscribe((_) => {});

    this.iplexDeviceConnectModeService
      .isHttpsModeObserver()
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((isHttpsMode) => {
        if (isHttpsMode) {
          this.dialogRef.close();
        }
      });

    this.iplexSyncService.onHttpsConnectMode(this.clientNameControl.value);
  }

  public confirmGuidanceMessage(): void {
    this.isConfirmedGuidanceMessage = true;
  }
}
